/**
 * @author       sarah.walloga@zumper.com (Sarah Walloga)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Tricks webpack to expose the runtime process instead of stringifying it
 */

// NOTE: webpack will replace all instances of process.env with a static object at compile time.
// Here we are circumventing that behavior using a trick to side-step that replacement. This
// gives us access to runtime environment variables, which we need to passing settings from the
// env, such as REDIS_SESSION_URL
// https://webpack.js.org/plugins/define-plugin/
// https://stackoverflow.com/a/49896877
export interface ProcessEnv {
  [key: string]: string | undefined
}

let processEnv: ProcessEnv = {}
try {
  /* istanbul ignore next */
  processEnv =
    typeof process !== 'undefined'
      ? (process as { [key: string]: any })['en'.concat('v')]
      : {}
} catch (e) {
  /* istanbul ignore next */
  processEnv = {}
}

export { processEnv }
